import deepmerge from "deepmerge";
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    box0: {
      main: "#f0f2f5",
      contrastText: "#344767",
    },

    box1: {
      main: "#ffffff",
      hover: "#f8f8f8",
      contrastText: "#7b809a",
    },

    box2: {
      main: "#42424a",
      dark: "#191919",
      contrastText: "#ffffff",
    },
  },
  typography: {
    h1: {
      fontSize: "1.8rem",
    },
    h3: {
      fontSize: "1.2rem",
      fontWeight: "600",
    },
    button: {
      textTransform: "none",
    },
  },

  constants: {
    SIDEBAR_WIDTH: "200px",
  },

  components: {
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: "bold",
        },
      },
    },
  },
});

declare module "@mui/material/styles" {
  interface Palette {
    box0: Palette["primary"];
    box1: Palette["primary"];
    box2: Palette["primary"];
  }

  interface PaletteOptions {
    box0?: PaletteOptions["primary"];
    box1?: PaletteOptions["primary"];
    box2?: PaletteOptions["primary"];
  }

  interface PaletteColor {
    hover?: string;
  }

  interface SimplePaletteColorOptions {
    hover?: string;
  }

  interface Theme {
    constants: {
      SIDEBAR_WIDTH?: string;
    };
  }

  interface ThemeOptions {
    constants: {
      SIDEBAR_WIDTH?: string;
    };
  }
}

export default theme;

export const devTheme = createTheme(
  deepmerge(theme, {
    palette: {
      box2: {
        main: "#8a00ff",
      },
    },
  }),
);
